import React from "react";
import { Box } from "@mui/material";
import CustomLabel from "./CustomLabel";

interface ViewPurchaseAndPrintProps {
  expense: any;
  items?: any[];
}

const ViewPurchaseAndPrint: React.FC<ViewPurchaseAndPrintProps> = ({
  expense,
  items = [],
}) => {
  const meta = expense?.metadata ?? {};
  const lines = Array.isArray(meta?.lines) ? meta.lines : [];
  const displayLines =
    lines.length > 0
      ? lines
      : (Array.isArray(items) ? items : []).map((it: any, idx: number) => ({
          id: it?.id ?? idx + 1,
          serviceLabel: it?.description || "Item",
          quantity: 1,
          unitCost: Number(it?.amount) || 0,
          discount: 0,
          totalPrice: Number(it?.amount) || 0,
        }));

  return (
    <Box sx={{ display: "grid", gridTemplateColumns: "1fr 0.5fr", gap: 2 }}>
      <Box >
        <CustomLabel text="Invoice Number" fontWeight={600} />
        <CustomLabel
          text={
            meta?.invoiceNumber ??
            meta?.invoice_nb ??
            "-"
          }
        />
      </Box>
      <Box />
      <Box >
        <CustomLabel text="Title" fontWeight={600} />
        <CustomLabel text={expense?.title || "-"} />
      </Box>
      <Box>
        <CustomLabel text="Status" fontWeight={600} />
        <CustomLabel text={expense?.status || "-"} />
      </Box>
      <Box>
        <CustomLabel text="Description" fontWeight={600} />
        <CustomLabel text={expense?.description || "-"} />
      </Box>
      <Box>
        <CustomLabel text="Notes" fontWeight={600} />
        <CustomLabel text={expense?.notes || "-"} />
      </Box>
      <Box>
        <CustomLabel text="Amount" fontWeight={600} />
        <CustomLabel
          text={`${Number(expense?.amount || 0).toFixed(2)} ${
            expense?.currency || ""
          }`.trim()}
        />
      </Box>
      <Box>
        <CustomLabel text="Date" fontWeight={600} />
        <CustomLabel
          text={
            expense?.createdAt
              ? new Date(expense.createdAt).toLocaleDateString()
              : "-"
          }
        />
      </Box>
      <Box>
        <CustomLabel text="Supplier Name" fontWeight={600} />
        <CustomLabel text={meta?.supplierName || "-"} />
      </Box>
      <Box>
        <CustomLabel text="Supplier Phone" fontWeight={600} />
        <CustomLabel text={meta?.supplierPhone || "-"} />
      </Box>
      <Box>
        <CustomLabel text="VAT %" fontWeight={600} />
        <CustomLabel text={String(meta?.vatPercent ?? "-")} />
      </Box>
      <Box>
        <CustomLabel text="Discount %" fontWeight={600} />
        <CustomLabel text={String(meta?.discountPercent ?? "-")} />
      </Box>

      <Box sx={{ gridColumn: "1 / -1" }}>
        <CustomLabel text="Items" fontWeight={600} />
        {displayLines.length === 0 ? (
          <CustomLabel text="No items found." />
        ) : (
          <Box
            sx={{
              border: "1px solid #e5e7eb",
              borderRadius: 1,
              mt: 1,
            }}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr",
                gap: 1,
                p: 2,
                backgroundColor: "#f9fafb",
                fontSize: 15,
                fontWeight: 600,
              }}
            >
              <Box>Item</Box>
              <Box>Qty</Box>
              <Box>Unit</Box>
              <Box>Disc%</Box>
              <Box>Total</Box>
            </Box>
            {displayLines.map((line: any) => (
              <Box
                key={line?.id || line?.serviceId || Math.random()}
                sx={{
                  display: "grid",
                  gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr",
                  gap: 1,
                  p: 2,
                  borderTop: "1px solid #e5e7eb",
                  fontSize: 15,
                }}
              >
                <Box>{line?.serviceLabel || "Item"}</Box>
                <Box>{line?.quantity ?? 1}</Box>
                <Box>{Number(line?.unitCost || 0).toFixed(2)}</Box>
                <Box>{Number(line?.discount || 0)}</Box>
                <Box>{Number(line?.totalPrice || 0).toFixed(2)}</Box>
              </Box>
            ))}
          </Box>
          )}
      </Box>

    </Box>
  );
};

export default ViewPurchaseAndPrint;
